import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
} from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { UserAlertsApi } from '../../api/user-alerts-api';

export type DeleteAvailabilityAlertModalProps = {
  onClose: () => void;
  candidateId: Candidate['id'];
};

export const DeleteAvailabilityAlertModal = ({
  onClose,
  candidateId,
}: DeleteAvailabilityAlertModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await UserAlertsApi.deleteCustomTalentAlert(candidateId);
    await UserAlertsApi.refreshUserAlerts();
    onClose();
  };

  return (
    <Modal name="DeleteAvailabilityAlertModal" size="confirm">
      <ModalHeader
        onClose={() => {
          onClose();
        }}
      >
        Delete availability alert?
      </ModalHeader>
      <ModalSection name="DELETE_CONFIRMATION">
        <Paragraph>
          Deleting this alert will cancel all your availability notifications
          for this talent. Alerts created by others won't be affected.
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          name="CANCEL_BUTTON"
          onClick={() => {
            onClose();
          }}
          variation="outline"
        >
          No
        </Button>
        <Button
          name="DELETE_BUTTON"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
